export default __webpack_public_path__ + "static/media/pdfWhite.61c2eeed.svg";